<template>
  <div class="wlx-unified-login-wrapper wlx-basic-static-wrapper" style="height:auto;">
    <!--登陆弹窗-->
    <el-dialog
      :show-close="true"
      :visible.sync="scanVisible"
      top="12%"
      :close-on-click-modal="false"
      width="500px"
      class="unified-login-dialog-style"
    >
      <div class="login-hade-tab clearfix">
        <div class="user-account-login active_login">
          <span style="float:left">账号登录</span>
        </div>
      </div>
      <div class="login-form-input clearfix">
        <el-form ref="form" :model="ruleForm" :rules="rules">
          <div class="from-account-login">
            <el-form-item prop="userName">
              <el-input placeholder="请输入账号" prefix-icon="wl-icon-user" v-model="ruleForm.userName"></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                placeholder="请输入密码"
                prefix-icon="wl-icon-mimaicon"
                v-model="ruleForm.password"
                type="password"
                @keyup.enter.native="login()"
              ></el-input>
            </el-form-item>
          </div>
          <el-form-item>
            <el-button type="primary" @click="login">登录</el-button>
          </el-form-item>
          <!-- <p class="p-enter-register" @click="rememberPassword">忘记密码</p> -->
          <p class="p-enter-register" @click="enterRegister">注册</p>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Bus from 'components/bus.js';
import { MU_UPATE_AUTH, MU_UPATE_SCHOOL } from "store/index";
export default {
  data() {
    return {
      scanVisible: false,
      ruleForm: {
        userName: "",
        password: "",
        phone: "",
        captcha: ""
      },
      rules: {
        userName: [
          { required: true, message: "请输入用户账号", trigger: "change" }
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "change" }
        ],
        phone: [{ required: true, message: "请输入手机号", trigger: "change" }],
        captcha: [
          { required: true, message: "请输入验证码", trigger: "change" }
        ]
      }
    };
  },
  props:{
      isShow:{
          type:Object,
          default:false
      }
  },
  computed: {
    userInfo() {
      return this.$store.state.auth;
    },
    association: function() {
      return this.$store.state.association;
    }
  },
  created() {
    if (localStorage["userId"] !== undefined) {
      this.$store.dispatch(MU_UPATE_AUTH).then(rt => {});
    }
    this.$store.dispatch(MU_UPATE_SCHOOL, { id: window.location.href });
  },
  watch:{
      isShow(val){
         this.scanVisible = val.isShow;
      }
  },
  methods: {
    enterRegister(){
      this.$router.push({
          name:'register'
      });
    },
    // 忘记密码
    rememberPassword() {
      this.$router.push({
        name: "password"
      });
    },
    openLoginDialog(){
      this.scanVisible = true;
    },
    login: function() {
      var that = this;
      this.loadingTip(true);
      this.$http
        .post("/api/XOrg/XLogin/Accountlogin", {
          userName: that.ruleForm.userName,
          userPwd: that.ruleForm.password,
          associationId: that.association.Id
        })
        .then(rst => {
          if (rst && rst.code > 0) {
            if (rst.code === 1) {
              localStorage["userName"] = this.ruleForm.userName;
              localStorage["userId"] = rst.userId;
            }
            this.$store.dispatch(MU_UPATE_AUTH).then(rt => {
              this.loadingTip(false);
              // 登录完获取回登录信息跳转
              this.scanVisible = false;
              this.$router.push({
                name: this.target_()
              });
            });
          } else {
            this.loadingTip(false);
            this.$message.warning(rst.msg);
          }
        });
    },
    loadingTip(is) {
      if (is) {
        this.$loading({
          lock: true,
          text: "正在登录..."
        });
      } else {
        this.$loading({}).close();
      }
    },
    target_() {
      let Urlname = "videoDetail";
      // if (this.$store.state.auth.userType === 1) {
      //   Urlname = "stuBasicInfo";
      // } else if (this.$store.state.auth.userType === 2) {
      //   Urlname = "teaApply";
      // } else if (this.$store.state.auth.userType === 3) {
      //   Urlname = "siteBasicInfo";
      // } else if (this.$store.state.auth.userType === 5) {
      //   Urlname = "systemManager";
      // }
      return Urlname;
    }
  }
};
</script>

<style lang="scss">
</style>
